<template>
  <div class="contact-from-wrapper move-up">
    <div v-if="sent">
      <b-alert
          show
          dismissible
          variant="success"
      >
        Votre message a été envoyé avec succès! Notre réceptioniste vous appèlera dans un délais de 24h.
        <br>
        Merci.
      </b-alert>
    </div>
    <form id="contact-form" v-if="!sent" action="mail.php" method="post">
      <div class="contact-page-form">
        <div style="color: white">
          Remplissez le formulaire ci-dessous et un membre de l’équipe Pied Pro
          vous contactera dans les prochaines 24 h.
          <br>
        </div>
        <br>
        <div class="row swapcolumns">
          <div class="col-lg-12 ">
            <div class="contact-input">
              <div class="contact-inner">
                <input v-model="form.fullName"
                       name="con_name"
                       type="text"
                       placeholder="Votre nom *">
              </div>
              <div class="contact-inner">
                <input v-model="form.email"
                       name="con_email"
                       type="email"
                       placeholder="Votre courriel *">
                <slot name="helpBlock" v-if="!isValidEmail(form.email)">
                  <div class="text-warning invalid-feedback mt-2" style="display: block;">
                    Ce format de courriel est invalide.
                  </div>
                </slot>
              </div>
            </div>
            <div class="contact-input">
              <div class="contact-inner">
                <input v-model="form.phone"
                       name="con_subject"
                       type="text"
                       placeholder="Votre numéro de téléphone *">
                <slot name="helpBlock" v-if="!isValidPhone(form.phone)">
                  <div class="text-warning invalid-feedback mt-2" style="display: block;">
                    Numéro de téléphone invalid. Doit contenir au minimum 7 chiffres.
                  </div>
                </slot>
              </div>
              <div class="contact-inner">
                <b-form-select v-model="form.selectedService" placeholder="Votre soin désiré.*" :options="soinDentaires" class="selectionStyle"></b-form-select>
              </div>
            </div>
            <div class="contact-inner contact-message">
<!--                                    <textarea v-model="form.message"-->
<!--                                              name="con_message"-->
<!--                                              placeholder="Votre message *">-->
<!--                                    </textarea>-->
<!--              <slot name="helpBlock" v-if="!isValidMessage(form.message)">-->
<!--                <div class="text-warning invalid-feedback mt-2" style="display: block;">-->
<!--                  Le message doit etre moins 500 characteres.-->
<!--                </div>-->
<!--              </slot>-->
            </div>
            <div class="contact-inner contact-message">
              <div class="align-middle text-center">
                <!--                <h6 class="font-weight&#45;&#45;bold mb-15 move-up">&ndash;&gt;-->
                <!--                                Choisissez votre journée idéale-->
                <!--                              </h6>-->
                <b-calendar
                    style="margin-left: auto; margin-right: auto"
                    class="reverse-responsive"
                    block
                    :min="min"
                    :date-disabled-fn="dateDisabled"
                    label-no-date-selected="Aucune date sélectionnée"
                    v-model="form.appointmentDate"
                    v-bind="labels[locale] || {}"
                    :locale="locale"
                    :start-weekday="weekday"
                    :hide-header="hideHeader"
                    :show-decade-nav="showDecadeNav"
                    @context="onContext"
                    label-help="Utilisez les flèches pour parcourir les dates du calendrier."
                ></b-calendar>
                <!--                              <slot name="helpBlock">-->
                <!--                                <div class="font-italic mt-2" style="display: block;">-->
                <!--                                  *Donnez-nous jusqu’à 24 h pour notre équipe pour vous contacter.-->
                <!--                                  *À noter que nous sommes fermés les fin de semaines.-->
                <!--                                </div>-->
                <!--                              </slot>-->
                <!--                <b-form-checkbox v-model="form.smsChecked"-->
                <!--                                 name="check-button"-->
                <!--                                 value="OUI"-->
                <!--                                 unchecked-value="NON"-->
                <!--                                 switch>-->
                <!--                  Voulez-vous recevoir des messageries par SMS ?-->
                <!--                </b-form-checkbox>-->
              </div>
            </div>
            <div class="contact-submit-btn" >
              <button @click="sendEmail"
                      class="ht-btn ht-btn-md"
                      style="width:100%; background-image: linear-gradient(218deg, #11b84d 0, #11b84d 50%, #11b84d 100%);">
                Envoyer
              </button>
              <p class="form-messege"></p>
            </div>
            <slot name="helpBlock" v-if="!isValidForm()">
              <div class="text-warning invalid-feedback mt-2" style="display: block;">
                *: Tous ces champs sont requis pour envoyer votre demande a la clinic Pied Pro Laval.
              </div>
            </slot>
          </div>

<!--          <div class="col-lg-5 align-middle text-center">-->
<!--            <h6 class="font-weight&#45;&#45;bold mb-15 move-up">-->
<!--              Choisissez votre journée idéale-->
<!--            </h6>-->
<!--            <b-calendar-->
<!--                style="margin-left: auto; margin-right: auto"-->
<!--                class="reverse-responsive"-->
<!--                block-->
<!--                :min="min"-->
<!--                :date-disabled-fn="dateDisabled"-->
<!--                label-no-date-selected="Aucune date sélectionnée"-->
<!--                v-model="form.appointmentDate"-->
<!--                v-bind="labels[locale] || {}"-->
<!--                :locale="locale"-->
<!--                :start-weekday="weekday"-->
<!--                :hide-header="hideHeader"-->
<!--                :show-decade-nav="showDecadeNav"-->
<!--                @context="onContext"-->
<!--                label-help="Utilisez les flèches pour parcourir les dates du calendrier."-->
<!--            ></b-calendar>-->
<!--            <slot name="helpBlock">-->
<!--              <div class="font-italic mt-2" style="display: block;">-->
<!--                *Donnez-nous jusqu’à 24 h pour notre équipe pour vous contacter.-->
<!--                *À noter que nous sommes fermés les fin de semaines.-->
<!--              </div>-->
<!--            </slot>-->
<!--            <br>-->
<!--          </div>-->
        </div>
      </div>
    </form>
  </div>
</template>

<script>
const querystring = require("querystring");
export default {
  name: "CalendarDentiste",
  data() {
    const now = new Date()
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    const minDate = new Date(today)
    // minDate.setDate(minDate.getDate()+5)
    return {
      min: minDate,
      dismissSecs: 5,
      dismissCountDown: 0,
      sent: false,
      form: {
        fullName: '',
        email: '',
        phone: '',
        message: '',
        appointmentDate: '',
        selectedService: null,
        smsChecked: 'NON',
        origin: ''
      },

      soinDentaires: [
        { value: null, text: 'Choisissez le soin podiatrique désirée' },
        { value: 'Ongles-incarnés', text: 'Ongles incarnés' },
        { value: 'Verrues', text: 'Verrues' },
        { value: 'Douleur-aux-pieds', text: 'Douleur aux pieds' },
        { value: 'Transpiration-excessive', text: 'Transpiration excessive' },
        { value: 'Pieds-diabétiques', text: 'Pieds Diabétiques' },
        { value: 'Soins-des-pieds', text: 'Soins des pieds' },
        { value: 'Orthèses-plantaires', text: 'Orthèses plantaires' },
        { value: 'autre', text: 'Autre' }
      ],
      // value: '',
      context: null,
      showDecadeNav: false,
      hideHeader: false,
      locale: 'fr-CA',
      locales: [
        { value: 'en-US', text: 'English US (en-US)' },
        { value: 'fr-CA', text: 'Francais CAD (fr-CA)' },
        { value: 'de', text: 'German (de)' },
        { value: 'ar-EG', text: 'Arabic Egyptian (ar-EG)' }
      ],
      weekday: 0,
      weekdays: [
        { value: 0, text: 'Sunday' },
        { value: 1, text: 'Monday' },
        { value: 6, text: 'Saturday' }
      ],
      labels: {
        de: {
          labelPrevDecade: 'Vorheriges Jahrzehnt',
          labelPrevYear: 'Vorheriges Jahr',
          labelPrevMonth: 'Vorheriger Monat',
          labelCurrentMonth: 'Aktueller Monat',
          labelNextMonth: 'Nächster Monat',
          labelNextYear: 'Nächstes Jahr',
          labelNextDecade: 'Nächstes Jahrzehnt',
          labelToday: 'Heute',
          labelSelected: 'Ausgewähltes Datum',
          labelNoDateSelected: 'Kein Datum gewählt',
          labelCalendar: 'Kalender',
          labelNav: 'Kalendernavigation',
          labelHelp: 'Mit den Pfeiltasten durch den Kalender navigieren'
        }
      }
    }
  },
  methods: {
    sendEmail(e) {
      if(this.isValidForm)
      {
        //Check the origin of the request (newspaper, googleAds, website main page)
        // switch( this.$route.name ) {
        //   case 'Newspaper':
        //     this.form.origin = 'Newspaper'
        //     break;
        //   case 'GoogleAds':
        //     this.form.origin = 'Online Ads'
        //     break;
        //   default:
        //     this.form.origin = 'From main website'
        // }

        e.preventDefault();
        this.$axios
            .post(
                "mail.php",
                querystring.stringify(this.form)
                // {headers:{"Content-Type" : "application/x-www-form-urlencoded", "Access-Control-Allow-Origin": "*"}}
            )
            .then(res => {
              // eslint-disable-next-line no-console
              console.log(res);
              this.sent = true;
            });
            // .catch(reason => {
            //   // eslint-disable-next-line no-console
            //   console.log((reason.response.data))
            // });
      }
    },
    isValidEmail(email) {
      const re = /^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    isValidPhone(phone) {
      const re = /^$|^(\+?\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
      return re.test(String(phone).toLocaleLowerCase())
    },
    isValidMessage(message) {
      const re = /^(.{0,100})$/;
      return re.test(String(message).toLocaleLowerCase())
    },
    isValidForm() {
      // if(this.form.email && this.form.fullName && this.form.message && this.form.phone) {
      if(this.isValidEmail(this.form.email)
          && this.isValidMessage(this.form.message)
          && this.isValidPhone(this.form.phone)
          && this.form.fullName != ''
          && this.form.email    != ''
          && this.form.message  != '' ) {
        return true
      }
      else {
        return false
      }
    },
    dateDisabled(ymd, date) {
      // Disable weekends (Sunday = `0`, Saturday = `6`) and
      // disable days that fall on the 13th of the month
      const weekday = date.getDay()
      // const day = date.getDate()
      // Return `true` if the date should be disabled
      return weekday === 0 || weekday === 6
    },
    onContext(ctx) {
      this.context = ctx
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    }

  }
}
</script>
